import { useStore } from 'effector-react'
import * as React from 'react'

import { $incomeByDay, incomeByDayListMounted, getIncomeByDay } from './model'

export const useKPIList = () => {
  React.useEffect(() => {
    incomeByDayListMounted()
  }, [])

  const incomeByDay = useStore($incomeByDay)
  const loading = useStore(getIncomeByDay.pending)
  return {
    incomeByDay,
    loading,
  }
}
